module.exports = __webpack_public_path__ + "static/media/default_credit_card.d95ebce3.svg";